import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { of, Subscription, timer } from 'rxjs';
import { catchError, switchMap, takeWhile } from 'rxjs/operators';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { PixResponse } from 'src/app/persistences/pix-response';
import { PedidoService } from 'src/app/services/pedido.service';

@Component({
  standalone: false,
  selector: 'app-pix-pagina',
  templateUrl: './pix-pagina.component.html',
  styleUrls: ['./pix-pagina.component.css']
})
export class PixPaginaComponent implements OnInit, OnDestroy {

  public pixCopiaECola: string;
  public pago = false;
  public expirado = false;

  private idPix: string;
  private pollingSub: Subscription;
  private redirecionamentoSub: Subscription;

  // Mesmos parâmetros usados pelo ERP/PDV: consulta a cada 3s, teto de 5 min.
  private readonly INTERVALO_MS = 3000;
  private readonly TEMPO_ESPERA_MS = 5 * 60 * 1000;
  // Após confirmar, aguarda 3s antes de voltar para a tela de pesquisa.
  private readonly REDIRECIONAMENTO_MS = 3000;

  constructor(
    private snackBarManager: SnackbarManager,
    private pedidoService: PedidoService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.pixCopiaECola = localStorage.getItem('pixCopiaECola');
    this.idPix = localStorage.getItem('pixId');
    this.iniciarPolling();
  }

  ngOnDestroy(): void {
    this.pararPolling();
    if (this.redirecionamentoSub) {
      this.redirecionamentoSub.unsubscribe();
    }
  }

  copiarCodigo(): void {
    navigator.clipboard.writeText(this.pixCopiaECola).then(() => {
      this.snackBarManager.openSnackBar('Código PIX copiado para a área de transferência!', 'Ok', 3000);
    });
  }

  continuarAguardando(): void {
    this.iniciarPolling();
  }

  private iniciarPolling(): void {
    // Sem o id da cobrança (ex.: pedidos anteriores a esta versão) não há como
    // consultar o status; mantém o QR Code exibido sem polling.
    if (!this.idPix) {
      return;
    }
    this.expirado = false;
    const totalTicks = this.TEMPO_ESPERA_MS / this.INTERVALO_MS;
    this.pollingSub = timer(0, this.INTERVALO_MS)
      .pipe(
        takeWhile(tick => tick < totalTicks),
        switchMap(() => this.pedidoService.statusPix(this.idPix)
          .pipe(catchError(() => of(null))))
      )
      .subscribe({
        next: (res: PixResponse | null) => {
          if (res && res.status === 'CONCLUIDA') {
            this.pago = true;
            this.pararPolling();
            this.agendarRetornoParaPesquisa();
          }
        },
        complete: () => {
          // O timer completou (5 min) sem confirmação do pagamento.
          if (!this.pago) {
            this.expirado = true;
          }
        }
      });
  }

  private pararPolling(): void {
    if (this.pollingSub) {
      this.pollingSub.unsubscribe();
      this.pollingSub = undefined;
    }
  }

  private agendarRetornoParaPesquisa(): void {
    // Confirmado o pagamento, retorna à tela de pesquisa (home) após 3s.
    this.redirecionamentoSub = timer(this.REDIRECIONAMENTO_MS).subscribe(() => {
      this.router.navigateByUrl('/home');
    });
  }
}
